import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

/** Combina clases de Tailwind resolviendo conflictos: la ultima gana. */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Texto localizado.
 *
 * El motor devuelve los tres idiomas siempre, y el que se muestra lo elige
 * quien mira la pantalla. Se cae a ingles y luego al propio id, para que un
 * idioma que falte degrade a algo legible en vez de a texto vacio.
 */
export function pick(
  dict: Partial<Record<string, string>> | null | undefined,
  locale: string,
): string {
  if (!dict) return ''
  return dict[locale] ?? dict.en ?? dict.fi ?? Object.values(dict)[0] ?? ''
}
